import { render, staticRenderFns } from "./WorkspaceLiteProjects.vue?vue&type=template&id=4e59c208&scoped=true&"
import script from "./WorkspaceLiteProjects.vue?vue&type=script&lang=js&"
export * from "./WorkspaceLiteProjects.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceLiteProjects.vue?vue&type=style&index=0&id=4e59c208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e59c208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e59c208')) {
      api.createRecord('4e59c208', component.options)
    } else {
      api.reload('4e59c208', component.options)
    }
    module.hot.accept("./WorkspaceLiteProjects.vue?vue&type=template&id=4e59c208&scoped=true&", function () {
      api.rerender('4e59c208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/Lite/WorkspaceLiteProjects.vue"
export default component.exports